import React, { useEffect, useState } from "react";
import LeaderBoard from "./Kryzen Dashboard Components/leaderboard";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import "swiper/css";
import { useRef } from "react";
import VideoComponent from "./Kryzen Dashboard Components/video_component";
import performRequest from "../../api/request";
import { Toast } from "../../CustomComponent/toast";
import { CustomErrorResponse } from "../../CustomComponent/custom_error_response";
import Marquee from "./Kryzen Dashboard Components/marquee";
import BirthdayPopup from "./Kryzen Dashboard Components/birthdayPopup";
import CelebrationPopup from "./Kryzen Dashboard Components/celebrationPopup";
import NotificationPopup from "./Kryzen Dashboard Components/notificationPopup";
import WebsiteStatusCarousel from "./Kryzen Dashboard Components/websiteStatus";
import "swiper/css/autoplay";
import { useNavigate } from "react-router";

const KryzenDashBoard = () => {
  const [tableData, setTableCount] = useState();
  const [followers, setFollowers] = useState({});
  const [count, setCount] = useState(0);
  const [socialMediaCount, setSocialMediaCount] = useState();
  const [socialMediaDailyCount, setSocialMediaDailyCount] = useState();
  const [socialMediaDailyCountPrv, setSocialMediaDailyCountPrv] = useState();
  const [websiteStatus, setWebsiteStatus] = useState([]);
  const [postingData, setPostingData] = useState([]);
  const swiperRef = useRef(null);
  const navigate = useNavigate();
  useEffect(() => {
    performRequest("GET", `/followers/get-followers/${1}`)
      .then((res) => {
        if (res.status === 200) {
          setFollowers(res.data);
        } else {
          Toast("error", "Error while getting Followers !");
        }
      })
      .catch((err) => {
        CustomErrorResponse(err);
      });
  }, []);

  useEffect(() => {
    performRequest("GET", "/followersCount/getsocialMediaCount/")
      .then((res) => {
        if (res.status === 200) {
          setSocialMediaCount(res?.data);
        } else {
          Toast("error", "Error while getting project Details!");
        }
      })
      .catch((err) => {
        CustomErrorResponse(err);
      });
  }, [tableData]);

  useEffect(() => {
    performRequest("GET", "/followersCount/getsocialDailyMediaCount/")
      .then((res) => {
        if (res.status === 200) {
          setSocialMediaDailyCount(res?.data);
        } else {
          Toast("error", "Error while getting project Details!");
        }
      })
      .catch((err) => {
        CustomErrorResponse(err);
      });
  }, [tableData]);

  useEffect(() => {
    const interval = setInterval(() => {
      performRequest("GET", "/allTablesCount/getCount")
        .then((res) => {
          if (res.status === 200) {
            setTableCount(res.data);
          } else {
            Toast("error", "Error while getting project Details!");
          }
        })
        .catch((err) => {
          CustomErrorResponse(err);
        });
    }, 60000);

    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    performRequest("GET", "/allTablesCount/getCount")
      .then((res) => {
        if (res.status === 200) {
          setTableCount(res.data);
        } else {
          Toast("error", "Error while getting project Details!");
        }
      })
      .catch((err) => {
        CustomErrorResponse(err);
      });
  }, []);

  useEffect(() => {
    performRequest("GET", "/api/learners")
      .then((res) => {
        if (res.status === 200) {
          setCount(res.data);
        } else {
          Toast("error", "Error while getting project Details!");
        }
      })
      .catch((err) => {
        CustomErrorResponse(err);
      });
  }, []);

  useEffect(() => {
    performRequest("GET", "/websiteStatus/getWebsiteStatus")
      .then((res) => {
        if (res.status === 200) {
          setWebsiteStatus(res.data);
        } else {
          Toast("error", "Error while getting project Details!");
        }
      })
      .catch((err) => {
        CustomErrorResponse(err);
      });
  }, []);

  useEffect(() => {
    performRequest("GET", "/postPlanning/get-schedules/")
      .then((res) => {
        if (res.status === 200) {
          setPostingData(res.data?.data);
        } else {
          Toast("error", "Error while getting Data!");
        }
      })
      .catch((err) => {
        CustomErrorResponse(err);
      });
  }, []);

  useEffect(() => {
    if (swiperRef.current && postingData?.length) {
      swiperRef.current.update();
      swiperRef.current.autoplay.start();
    }
  }, [postingData]);

  return (
    <>
      <div className="page layout-fluid">
        <div className="page-wrapper">
          <div className="page-body mt-0">
            <div className="container-xl">
              <div className="row row-cards">
                <div className="col-3">
                  <div className="row row-deck row-cards">
                    <div className="col-lg-12 ">
                      <div className="card card-sm">
                        <div className="card-body bg-green-lt">
                          <div className="align-items-center text-center p-0 m-0">
                            <div className="col">
                              <div
                                className="text-center fw-bold"
                                style={{
                                  fontSize: "820%",
                                }}
                              >
                                {count}
                              </div>
                              <div
                                className="text-center fw-bold"
                                style={{
                                  fontSize: "280%",
                                }}
                              >
                                MASTERCLASS USERS
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    {/* <div className="col-md-12 col-lg-12">
                      <div className="card">
                        <div
                          className="card-header"
                          style={{
                            justifyContent: "center",
                            padding: "10px 0px 0px 0px",
                          }}
                        >
                          <h3
                            className="fw-semibold"
                            style={{
                              fontSize: "220%",
                            }}
                          >
                            ONGOING PROJECTS
                          </h3>
                        </div>
                        <ProjectTrackingTable />
                      </div>
                    </div> */}
                    {/* <div className="col-md-12 col-lg-12">
                      <div className="card">
                        <div
                          className="card-header"
                          style={{
                            justifyContent: "center",
                            padding: "10px 0px 0px 0px",
                          }}
                        >
                          <h3
                            className="fw-semibold"
                            style={{
                              fontSize: "220%",
                            }}
                          >
                            SALES LEADERBOARD
                          </h3>
                        </div>
                        <LeaderBoard />
                      </div>
                    </div> */}
                    <div className="col-md-12 col-lg-12">
                      <div className="row row-deck row-cards">
                        {/* <div className="col-lg-6">
                          <div className="card card-sm">
                            <div className="card-body bg-orange-lt">
                              <div className="row align-items-center">
                                <div className="col">
                                  <div
                                    className="text-center fw-bold"
                                    style={{
                                      fontSize: "380%",
                                      marginTop: "-20px",
                                      marginBottom: "-10px",
                                    }}
                                  >
                                    {(tableData && tableData?.quotations) || 0}
                                  </div>
                                  <div className="fs-1 text-center fw-bold">
                                    QUOTATION
                                  </div>
                                  <hr className="my-3" />
                                  <div className="text-muted text-center">
                                    <span
                                      className="fw-bold"
                                      style={{
                                        fontSize: "180%",
                                      }}
                                    >
                                      {(tableData &&
                                        tableData?.quotationsToday) ||
                                        0}
                                    </span>
                                    <span
                                      className="fw-bold"
                                      style={{
                                        fontSize: "180%",
                                      }}
                                    >
                                      {" "}
                                      TODAY
                                    </span>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div> */}
                        <div className="col-lg-6">
                          <div className="card card-sm">
                            <div className="card-body bg-orange-lt">
                              <div className="row align-items-center">
                                <div className="col">
                                  <div
                                    className="text-center fw-bold"
                                    style={{
                                      fontSize: "380%",
                                      marginTop: "-20px",
                                      marginBottom: "-10px",
                                    }}
                                  >
                                    {(tableData &&
                                      tableData?.enquiryListToday) ||
                                      0}
                                  </div>
                                  <div className="fs-1 text-center fw-bold">
                                    TODAY ENQUIRIES RECEIVED
                                  </div>
                                  <hr className="my-2" />{" "}
                                  <div className="text-muted text-center">
                                    <span
                                      className="fw-bold"
                                      style={{
                                        fontSize: "180%",
                                      }}
                                    >
                                      {(tableData && tableData?.enquiryList) ||
                                        0}
                                    </span>
                                    <div>
                                      <span
                                        className="fs-1 text-center fw-bold"
                                        // style={{
                                        //   fontSize: "170%",
                                        // }}
                                      >
                                        {" "}
                                        TOTAL ENQUIRIES
                                      </span>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="col-lg-6">
                          <div className="card card-sm">
                            <div className="card-body bg-orange-lt">
                              <div className="row align-items-center">
                                <div className="col">
                                  <div
                                    className="text-center fw-bold"
                                    style={{
                                      fontSize: "380%",
                                      marginTop: "-20px",
                                      marginBottom: "-10px",
                                    }}
                                  >
                                    {(tableData && tableData?.leadsToday) || 0}
                                  </div>
                                  <div className="fs-1 text-center fw-bold">
                                    TODAY <div>LEADS </div> CATERED{" "}
                                  </div>
                                  <hr className="my-2" />{" "}
                                  <div className="text-muted text-center">
                                    <span
                                      className="fw-bold"
                                      style={{
                                        fontSize: "180%",
                                      }}
                                    >
                                      {(tableData && tableData?.leads) || 0}
                                    </span>
                                    <div>
                                      <span
                                        className="fs-1 text-center fw-bold"
                                        // style={{
                                        //   fontSize: "180%",
                                        // }}
                                      >
                                        {" "}
                                        TOTAL{" "}
                                        <div className="text-center">LEADS</div>
                                      </span>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="col-lg-6">
                          <div className="card card-sm">
                            <div className="card-body bg-orange-lt">
                              <div className="row align-items-center">
                                <div className="col">
                                  <div
                                    className="text-center fw-bold"
                                    style={{
                                      fontSize: "380%",
                                      marginTop: "-20px",
                                      marginBottom: "-10px",
                                    }}
                                  >
                                    {(tableData &&
                                      tableData?.webinarPurchases) ||
                                      0}
                                  </div>
                                  <div className="fs-1 text-center fw-bold">
                                    WEBINAR
                                  </div>
                                  <hr className="my-3" />{" "}
                                  <div className="text-muted text-center">
                                    <span
                                      className="fw-bold"
                                      style={{
                                        fontSize: "180%",
                                      }}
                                    >
                                      {(tableData &&
                                        tableData?.webinarPurchasesToday) ||
                                        0}
                                    </span>
                                    <span
                                      className="fs-1 text-center fw-bold"
                                      //    style={{
                                      //    fontSize: "300%",
                                      //  }}
                                    >
                                      {" "}
                                      TODAY
                                    </span>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="col-lg-6">
                          <div className="card card-sm">
                            <div className="card-body bg-orange-lt">
                              <div className="row align-items-center">
                                <div className="col">
                                  <div
                                    className="text-center fw-bold"
                                    style={{
                                      fontSize: "380%",
                                      marginTop: "-20px",
                                      marginBottom: "-10px",
                                    }}
                                  >
                                    {(tableData &&
                                      tableData?.siteInspections &&
                                      tableData?.clientProjects &&
                                      tableData.clientProjects +
                                        tableData.siteInspections) ||
                                      0}
                                  </div>
                                  <div className="fs-1 text-center fw-bold">
                                    INSPECTION
                                  </div>
                                  <hr className="my-3" />
                                  <div className="text-muted text-center">
                                    <span
                                      className="fw-bold"
                                      style={{
                                        fontSize: "180%",
                                      }}
                                    >
                                      {(tableData &&
                                        tableData?.siteInspectionsToday) ||
                                        0}
                                    </span>
                                    <span
                                      className="fs-1 text-center fw-bold"
                                      // style={{
                                      //   fontSize: "180%",
                                      // }}
                                    >
                                      {" "}
                                      TODAY
                                    </span>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="col-lg-6">
                          <div className="card card-sm ">
                            <div className="card-body bg-orange-lt">
                              <div className="row align-items-center">
                                <div className="col">
                                  <div
                                    className="text-center fw-bold"
                                    style={{
                                      fontSize: "380%",
                                      marginTop: "-20px",
                                      marginBottom: "-10px",
                                    }}
                                  >
                                    {(tableData && tableData?.clientProjects) ||
                                      0}
                                  </div>
                                  <div className="fs-1 text-center fw-bold">
                                    FARMS
                                  </div>
                                  <hr className="my-3" />{" "}
                                  <div className="text-muted text-center">
                                    <span
                                      className="fw-bold"
                                      style={{
                                        fontSize: "180%",
                                      }}
                                    >
                                      {(tableData &&
                                        tableData?.clientProjectsToday) ||
                                        0}
                                    </span>
                                    <span
                                      className="fs-1 text-center fw-bold"
                                      // style={{
                                      //   fontSize: "180%",
                                      // }}
                                    >
                                      {" "}
                                      TODAY
                                    </span>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        {/* <div className="col-lg-6">
                          <div className="card card-sm">
                            <div className="card-body bg-danger-lt">
                              <div className="row align-items-center">
                                <div className="col">
                                  <div
                                    className="text-center fw-bolder"
                                    style={{
                                      fontSize: "380%",
                                    }}
                                  >
                                    {(tableData &&
                                      tableData?.pendingFollowupToday) ||
                                      0}
                                  </div>
                                  <div className="fs-1 text-center fw-bolder">
                                    PENDING FOLLOWUPS
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div> */}
                        <div className="col-lg-6">
                          <div className="card card-sm">
                            <div className="card-body bg-danger-lt">
                              <div className="row align-items-center">
                                <div className="col">
                                  <div
                                    className="text-center fw-bolder"
                                    style={{
                                      fontSize: "380%",
                                    }}
                                  >
                                    {(tableData &&
                                      tableData?.totalMissedCallToday) ||
                                      0}
                                  </div>
                                  <div className="fs-1 text-center fw-bolder">
                                    MISSED CALLS
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-9">
                  <div className="row row-deck row-cards">
                    <div className="col-lg-12">
                      <div className="row row-deck row-cards">
                        <div className="col-6 col-lg">
                          <div className="card card-sm">
                            <div
                              className="card-body text-white"
                              style={{
                                backgroundRepeat: "no-repeat",
                                backgroundSize: "100% 100%",
                                backgroundImage:
                                  "url(https://t4.ftcdn.net/jpg/02/09/79/37/360_F_209793746_2dQuBLsUO9bYZ0sDJxvlp6KclqdrS2RL.webp)",
                              }}
                            >
                              <div className="row align-items-center">
                                <div className="col">
                                  <div
                                    className="text-center fw-bold"
                                    style={{
                                      fontSize: "330%",
                                    }}
                                  >
                                    {`${socialMediaCount?.instagram?.followers}` ||
                                      "N/A"}
                                  </div>
                                  <div className="fs-1 text-center fw-bold">
                                    INSTAGRAM
                                  </div>
                                  <hr className="m-1 p-0"></hr>
                                  <div className="text-center">
                                    {" "}
                                    <span
                                      className="fs-2 text-center "
                                      style={{
                                        color: "yellow",
                                        fontWeight: "900",
                                      }}
                                    >
                                      +
                                      {socialMediaDailyCount?.instagram
                                        ?.newFollowers || "0"}
                                      &nbsp; /&nbsp;
                                      {socialMediaDailyCount?.instagram
                                        ?.newPosts || "0"}{" "}
                                      &nbsp;&nbsp; F / P TODAY
                                    </span>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="col-6 col-lg">
                          <div className="card card-sm">
                            <div
                              className="card-body text-white"
                              style={{
                                backgroundColor: "#0773E2",
                              }}
                            >
                              <div className="row align-items-center">
                                <div className="col">
                                  <div
                                    className="text-center fw-bold"
                                    style={{
                                      fontSize: "330%",
                                    }}
                                  >
                                    {followers.facebook || "N/A"}
                                  </div>
                                  <div className="fs-1 text-center fw-bold">
                                    FACEBOOK
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="col-6 col-lg">
                          <div className="card card-sm">
                            <div
                              className="card-body text-white"
                              style={{
                                backgroundColor: "#15487D",
                              }}
                            >
                              <div className="row align-items-center">
                                <div className="col">
                                  <div
                                    className="text-center fw-bold"
                                    style={{
                                      fontSize: "330%",
                                    }}
                                  >
                                    {followers.linkedin || "N/A"}
                                  </div>
                                  <div className="fs-1 text-center fw-bold">
                                    LINKEDIN
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="col-6 col-lg">
                          <div className="card card-sm">
                            <div
                              className="card-body text-white"
                              style={{
                                backgroundRepeat: "no-repeat",
                                backgroundSize: "100% 100%",
                                backgroundImage:
                                  "url(https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSYQh_7ACo0pEaS63mnzaxqTtfw6L_5KmZJ5w&usqp=CAU)",
                              }}
                            >
                              <div className="row align-items-center">
                                <div className="col">
                                  <div
                                    className="text-center fw-bold"
                                    style={{
                                      fontSize: "330%",
                                    }}
                                  >
                                    {socialMediaCount?.youtube?.followers ||
                                      "N/A"}
                                  </div>
                                  <div className="fs-1 text-center fw-bold">
                                    YOUTUBE
                                  </div>
                                  <hr className="m-1 p-0"></hr>
                                  <div className="text-center">
                                    {" "}
                                    <span
                                      className="fs-2 text-center "
                                      style={{
                                        color: "yellow",
                                        fontWeight: "900",
                                      }}
                                    >
                                      +
                                      {socialMediaDailyCount?.youtube
                                        ?.newFollowers || "0"}
                                      &nbsp; /&nbsp;
                                      {socialMediaDailyCount?.youtube
                                        ?.newPosts || "0"}{" "}
                                      &nbsp;&nbsp; F / P TODAY
                                    </span>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="col-6 col-lg">
                          <div className="card card-sm">
                            <div
                              className="card-body text-white"
                              style={{
                                backgroundRepeat: "no-repeat",
                                backgroundSize: "100% 100%",
                                backgroundImage:
                                  "url(https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcT5f5HNedkeA0U8jol-VQ8vq-jA4E0zA2tneA&usqp=CAU)",
                              }}
                            >
                              <div className="row align-items-center">
                                <div className="col">
                                  <div
                                    className="text-center fw-bold"
                                    style={{
                                      fontSize: "330%",
                                    }}
                                  >
                                    {followers.google || "N/A"}
                                  </div>
                                  <div className="fs-1 text-center fw-bold">
                                    GOOGLE
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    {/* 
                    <div className="col-md-12 col-lg-4">
                      <div className="card">
                        <div
                          className="card-header"
                          style={{
                            justifyContent: "center",
                            padding: "10px 0px 0px 0px",
                          }}
                        >
                          <h3
                            className="fw-semibold"
                            style={{
                              fontSize: "220%",
                            }}
                          >
                            EEP LEADERBOARD
                          </h3>
                        </div>
                        <EEPLeaderBoard />
                      </div>
                    </div> */}
                    <div className="col-md-12 col-lg-5">
                      <div className="card">
                        <div
                          className="card-header"
                          style={{
                            justifyContent: "center",
                            padding: "10px 0px 0px 0px",
                          }}
                        >
                          <h3
                            className="fw-semibold cursor-pointer"
                            style={{
                              fontSize: "290%",
                              padding: "10px 0px",
                            }}
                            onClick={() => navigate("/sales-dashboard")}
                          >
                            SALES LEADERBOARD
                          </h3>
                        </div>
                        <LeaderBoard />
                        <BirthdayPopup />
                        <NotificationPopup />
                        <CelebrationPopup />
                      </div>
                    </div>
                    {/* <div className="col-md-12 col-lg-7">
                     <VideoComponent /> 
                      
                    </div> */}
                    <div className="col-md-12 col-lg-7">
                      <div
                        className="card shadow-sm"
                        style={{
                          width: "300px",
                          height: "620px",
                        }}
                      >
                        <div className="card-header">
                          {/* <strong>Content Schedule</strong> */}
                          <h3
                            className="fw-semibold"
                            style={{
                              fontSize: "290%",
                              // padding: "5px 0px",
                            }}
                          >
                            CONTENT SCHEDULE
                          </h3>
                        </div>

                        <div className="card-body p-2">
                          {/* <Swiper
                            modules={[Autoplay]}
                            direction="vertical"
                            slidesPerView={4}
                            spaceBetween={8}
                            autoplay={{
                              delay: 1500,
                              disableOnInteraction: false,
                            }}
                            loop={true}
                            style={{
                              height: "540px",
                            }}
                          > */}
                          <Swiper
                            modules={[Autoplay]}
                            direction="vertical"
                            slidesPerView={4}
                            spaceBetween={8}
                            loop={postingData?.length > 4}
                            observer={true}
                            observeParents={true}
                            watchOverflow={false}
                            autoplay={{
                              delay: 1500,
                              disableOnInteraction: false,
                              pauseOnMouseEnter: false,
                            }}
                            onSwiper={(swiper) => {
                              swiperRef.current = swiper;

                              requestAnimationFrame(() => {
                                swiper.update();
                                swiper.autoplay.start();
                              });
                            }}
                            style={{ height: "540px" }}
                          >
                            {postingData?.map((item) => (
                              <SwiperSlide key={item.scheduleGroupId}>
                                <div
                                  className={`card card-sm ${
                                    Number(item.uploadedMediaCount) < 15
                                      ? "bg-red-lt"
                                      : "bg-green-lt"
                                  }`}
                                >
                                  <div className="card-body p-2">
                                    <div style={{ fontSize: "15px" }}>
                                      <span className="text-muted">
                                        <b> Page Name:</b>
                                      </span>
                                      <span className="fw-bold ms-1">
                                        {item.pageName}
                                      </span>
                                    </div>
                                    <div style={{ fontSize: "15px" }}>
                                      <span className="text-muted">
                                        <b> Topic Name:</b>
                                      </span>
                                      <span className="fw-bold ms-1">
                                        {item.scheduleName}
                                      </span>
                                    </div>

                                    <div style={{ fontSize: "15px" }}>
                                      <span className="text-muted">
                                        <b>Days:</b>
                                      </span>
                                      <span className="fw-bold ms-1">
                                        {item.days}
                                      </span>
                                    </div>

                                    <div style={{ fontSize: "15px" }}>
                                      <span className="text-muted">
                                        <b>Type:</b>
                                      </span>
                                      <span className="fw-bold ms-1">
                                        {item.contentType}
                                      </span>
                                    </div>

                                    <div
                                      className="fw-bold "
                                      style={{ fontSize: "15px" }}
                                    >
                                      <span className="text-muted">
                                        <b>Media:</b>
                                      </span>
                                      <span
                                        className="ms-1"
                                        style={{ fontSize: "18px" }}
                                      >
                                        {item.uploadedMediaCount} /{" "}
                                        {item.totalSchedules}
                                      </span>
                                    </div>
                                  </div>
                                </div>
                              </SwiperSlide>
                            ))}
                          </Swiper>
                        </div>
                      </div>
                    </div>
                    <div className="col-12" key={new Date()}>
                      <Marquee direction={"left"} />
                    </div>
                    <div className="col-12 mt-3">
                      <WebsiteStatusCarousel data={websiteStatus?.data} />
                    </div>
                  </div>
                </div>
                <div
                  className="col-12  text-center text-uppercase fw-bold "
                  style={{
                    fontSize: "2.4rem",
                    display: "flex",
                    justifyContent: "center",
                  }}
                >
                  We are India's number one hydroponic construction company.
                </div>
              </div>
              {/* <div className="row row-deck row-cards"> */}
              {/* <div
                  className="col-lg-3 text-center"
                  style={{
                    justifyContent: "center",
                    display: "flex",

                    alignItems: "center",
                    justifyItems: "center",
                  }}
                >
                  <div className="text-center">
                    <img
                      src={
                        "https://res.cloudinary.com/dph1m5tq7/image/upload/v1732944677/kryzenLogo_khacdq.png"
                      }
                      width={"80%"}
                      className="align-center"
                      alt="kryzenLogo"
                    />
                  </div>
                </div>
                <div className="col-lg-9">
                  <div className="row row-deck row-cards">
                    <div className="col-6 col-lg">
                      <div className="card card-sm">
                        <div
                          className="card-body text-white"
                          style={{
                            backgroundRepeat: "no-repeat",
                            backgroundSize: "100% 100%",
                            backgroundImage:
                              "url(https://t4.ftcdn.net/jpg/02/09/79/37/360_F_209793746_2dQuBLsUO9bYZ0sDJxvlp6KclqdrS2RL.webp)",
                          }}
                        >
                          <div className="row align-items-center">
                            <div className="col">
                              <div
                                className="text-center fw-bold"
                                style={{
                                  fontSize: "330%",
                                }}
                              >
                                43900{" "}
                              </div>
                              <div className="fs-1 text-center fw-bold">
                                INSTAGRAM
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="col-6 col-lg">
                      <div className="card card-sm">
                        <div
                          className="card-body text-white"
                          style={{
                            backgroundColor: "#0773E2",
                          }}
                        >
                          <div className="row align-items-center">
                            <div className="col">
                              <div
                                className="text-center fw-bold"
                                style={{
                                  fontSize: "330%",
                                }}
                              >
                                19000
                              </div>
                              <div className="fs-1 text-center fw-bold">
                                FACEBOOK
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="col-6 col-lg">
                      <div className="card card-sm">
                        <div
                          className="card-body text-white"
                          style={{
                            backgroundColor: "#15487D",
                          }}
                        >
                          <div className="row align-items-center">
                            <div className="col">
                              <div
                                className="text-center fw-bold"
                                style={{
                                  fontSize: "330%",
                                }}
                              >
                                3540
                              </div>
                              <div className="fs-1 text-center fw-bold">
                                LINKEDIN
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="col-6 col-lg">
                      <div className="card card-sm">
                        <div
                          className="card-body text-white"
                          style={{
                            backgroundRepeat: "no-repeat",
                            backgroundSize: "100% 100%",
                            backgroundImage:
                              "url(https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSYQh_7ACo0pEaS63mnzaxqTtfw6L_5KmZJ5w&usqp=CAU)",
                          }}
                        >
                          <div className="row align-items-center">
                            <div className="col">
                              <div
                                className="text-center fw-bold"
                                style={{
                                  fontSize: "330%",
                                }}
                              >
                                18900
                              </div>
                              <div className="fs-1 text-center fw-bold">
                                YOUTUBE
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-6 col-lg">
                      <div className="card card-sm">
                        <div
                          className="card-body text-white"
                          style={{
                            backgroundRepeat: "no-repeat",
                            backgroundSize: "100% 100%",
                            backgroundImage:
                              "url(https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcT5f5HNedkeA0U8jol-VQ8vq-jA4E0zA2tneA&usqp=CAU)",
                          }}
                        >
                          <div className="row align-items-center">
                            <div className="col">
                              <div
                                className="text-center fw-bold"
                                style={{
                                  fontSize: "330%",
                                }}
                              >
                                4.7/5
                              </div>
                              <div className="fs-1 text-center fw-bold">
                                GOOGLE
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div> */}

              {/* <div className="col-md-12 col-lg-3">
                  <div className="card">
                    <div
                      className="card-header"
                      style={{
                        justifyContent: "center",
                        padding: "10px 0px",
                      }}
                    >
                      <h3
                        className="fw-semibold"
                        style={{
                          fontSize: "220%",
                        }}
                      >
                        ONGOING PROJECTS
                      </h3>
                    </div>
                    <ProjectTrackingTable />
                  </div>
                </div>
                <div className="col-md-12 col-lg-3">
                  <div className="card">
                    <div
                      className="card-header"
                      style={{
                        justifyContent: "center",
                        padding: "10px 0px",
                      }}
                    >
                      <h3
                        className="fw-semibold"
                        style={{
                          fontSize: "220%",
                        }}
                      >
                        SALES LEADERBOARD
                      </h3>
                    </div>
                    <LeaderBoard />
                  </div>
                </div>
                <div className="col-md-12 col-lg-6">
                  <div className="card">
                    <VideoComponent />
                  </div>
                </div>
                <div
                  className="col-12 text-center text-uppercase fw-bold"
                  style={{
                    fontSize: "320%",
                    display: "flex",
                    justifyContent: "center",
                  }}
                >
                  We are India's number one hydroponic construction company.
                </div> */}
              {/* </div> */}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default KryzenDashBoard;
